import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { applyStoredTheme } from './app/core/theme.service';

/**
 * Before bootstrap, so the first paint is already the right colour.
 *
 * ThemeService applies the same attribute, but not until Angular has constructed it - by which point the
 * browser has painted the page background, and a dark-theme user sees a white flash on every load.
 *
 * Here rather than as an inline <script> in index.html: an inline script is the only way to beat the initial
 * paint entirely, but it would be blocked by a strict Content-Security-Policy in a deployed environment and
 * would have to repeat the cookie parsing in untyped, untested HTML. This runs a few milliseconds later, with
 * only an empty <app-root> on screen.
 */
applyStoredTheme();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
